// React 19 compatibility shim
// Re-export React and provide a createFactory named export for older deps

// Import the real React entry bypassing the 'react$' alias via a separate alias 'react-orig$'
import * as ReactOriginal from 'react-orig';

// Support both ESM/CJS default interop
const ReactDefault = ReactOriginal.default || ReactOriginal;

export * from 'react-orig';
export default ReactDefault;

export const createFactory = (type) => ReactDefault.createElement.bind(null, type);


